<template>
  <vs-popup
    :title="'Booking has broken policies'"
    :active.sync="showThisPopup"
    @close="handlePopupClose"
    class="booking-policies-warning-popup"
  >
    <vs-row class="booking-policies-warning-popup-content">
      <vs-col>
        <vs-row v-if="hardLimitFails && hardLimitFails.length > 0">
          <vs-col>
            <h6>Booking has the following hard limit warnings:</h6>
            <vs-row
              v-for="(hardLimitFail, index) in hardLimitFails"
              :key="'hardLimitFail-' + index"
            >
              <vs-col>
                {{
                  `${POLICY_TYPE.nameof(hardLimitFail.policyType)}: ${
                    hardLimitFail.message
                  }`
                }}
              </vs-col>
            </vs-row>
          </vs-col>
        </vs-row>

        <vs-row v-if="softLimitFails && softLimitFails.length > 0">
          <vs-col>
            <h6>Booking has the following soft limit warnings:</h6>
            <vs-row
              v-for="(softLimitFail, index) in softLimitFails"
              :key="'softLimitFail-' + index"
            >
              <vs-col>
                {{
                  `${POLICY_TYPE.nameof(softLimitFail.policyType)}: ${
                    softLimitFail.message
                  }`
                }}
              </vs-col>
            </vs-row>
          </vs-col>
        </vs-row>
      </vs-col>
    </vs-row>

    <vs-row vs-w="12" vs-justify="flex-end">
      <vs-button
        color="warning"
        type="border"
        class="mr-4"
        v-if="
          $AuthService.hasPermissionForActiveVenue(
            'vp.vp.booking.editbookings'
          )
        "
        @click="handleRejectBooking"
        >Reject booking</vs-button
      >
      <vs-button
        color="primary"
        @click="handleAcceptBooking"
        v-if="!hardLimitFails || hardLimitFails.length === 0"
        >Accept booking</vs-button
      >
    </vs-row>
  </vs-popup>
</template>

<script>
import { POLICY_TYPE } from "@/store/modules/marcom/data-model/policy-configurations";

export default {
  components: {},
  props: {},
  data() {
    return {
      POLICY_TYPE,
      showThisPopup: false,
      softLimitFails: [],
      hardLimitFails: [],
    };
  },
  computed: {},
  methods: {
    show(bookingAndWarnings) {
      this.hardLimitFails = bookingAndWarnings.hardLimitFails;
      this.softLimitFails = bookingAndWarnings.softLimitFails;
      this.showThisPopup = true;
    },
    handleAcceptBooking() {
      this.$emit("booking-accepted");
      this.handlePopupClose();
    },
    handleRejectBooking() {
      this.$emit("booking-rejected");
      this.handlePopupClose();
    },
    handlePopupClose() {
      this.hardLimitFails = undefined;
      this.softLimitFails = undefined;
      this.showThisPopup = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.booking-policies-warning-popup::v-deep {
  z-index: 57000;
  .vs-popup {
    width: 1080px;

    .vs-popup--content {
      overflow: hidden;

      .booking-policies-warning-popup-content {
        max-height: calc(100vh - 225px);
        overflow: auto;
        margin-top: 10px;
        margin-bottom: 10px;
      }
    }
  }
}
</style>
